<template>
  <div class='ClientsHeader'>
    <div class="c-nome">
      Nome
    </div>
    <div style="width: 12%" class="mobile-none">
      Usuário
    </div>
    <div class="c-email">
      Email
    </div>
    <div style="width: 10%" class="mobile-none">
      Localização
    </div>
    <div style="width: 10%" class="mobile-none">
      Pedidos
    </div>
    <div style="width: 10%" class="mobile-none">
      Dinheiro gasto
    </div>
    <div class="c-pedido">
      Último pedido
    </div>
    <div class="acoes">
      Ações
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClientsHeader',
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped>
.ClientsHeader {
  display: flex;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
  padding: 1%;
}

.acoes {
  width: 6%;
}

.c-nome {
  width: 12%;
}

.c-email {
  width: 26%;
}

.c-pedido {
  width: 14%;
}

@media (max-width: 500px) {
  .mobile-none {
    display: none;
  }
  .c-nome {
    width: 20%;
  }
  .c-email {
    width: 40%;
  }
  .c-pedido {
    width: 20%;
  }
  .acoes {
    width: 20%;
  }
}
</style>
